// extracted by mini-css-extract-plugin
export default {"controls":"BlockControls_controls__sPiid","btn":"BlockControls_btn__AJwoH","deleteBtn":"BlockControls_deleteBtn__-QSY0"};